import { Reveal } from "@/components/Reveal";
import { MANIFESTO, IMAGES } from "@/lib/site";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="relative py-24 lg:py-32 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="rsm-eyebrow mb-5">Why Rolling Stone</div>
              <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-white leading-[1.12]">
                We run the whole path, not a slice of it.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="relative mt-10 overflow-hidden rounded-2xl border border-white/10">
                <img
                  src={IMAGES.office}
                  alt="A person standing in a modern office looking out over the city at dusk"
                  className="h-64 w-full object-cover opacity-80"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0d14] to-transparent" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8 lg:pl-8">
            <div className="space-y-px">
              {MANIFESTO.map((m, i) => (
                <Reveal key={m.n} delay={i * 0.08}>
                  <div className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 border-t border-white/10 py-8 lg:py-10 transition-colors hover:border-amber-400/30">
                    <span className="font-mono text-sm text-amber-400/70 pt-1.5">
                      / {m.n}
                    </span>
                    <div>
                      <h3 className="font-display text-2xl sm:text-3xl font-bold text-white group-hover:text-amber-400 transition-colors">
                        {m.title}
                      </h3>
                      <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-400">
                        {m.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
